import { Box, Grid, Typography } from '@material-ui/core';
import React from 'react';

import { Paper } from 'features/app/components/Paper';
import { ShortBrandedGiftCard } from 'features/my-gift-cards/ts/ShortBrandedGiftCard';
import { useStyles } from 'features/my-gift-cards/components/CardListItem/styles';
import BaseButton from 'features/app/components/BaseButton';
import { myGiftCardsPaths } from 'features/my-gift-cards/routes/paths';
import { useDispatch } from 'react-redux';
import { requestRemoveGiftCardAction } from 'features/my-gift-cards/redux/action';
import { useSelector } from 'store';
import { SmallSpinner } from 'features/app/components/SmallSpinner';
import { useTranslation } from 'hooks/useTranslation';
import { confirmDialog } from 'features/app/utils/confirmDialog';
import i18n from 'locales/i18n';

interface CardListItemProps extends ShortBrandedGiftCard {}

export const CardListItem: React.FC<CardListItemProps> = ({ banner_image, gift_card_image, brand_name, id }) => {
  const direction = i18n.dir();
  const classes = useStyles({ direction });
  const dispatch = useDispatch();
  const { t } = useTranslation('my-gift-cards');

  const isLoading = useSelector(state => state.giftCards.isLoading);

  const handleDeleteClick = async () => {
    const canDelete = await confirmDialog({ title: t('deleteCardConfirmation') });
    if (!canDelete) {
      return;
    }
    dispatch(requestRemoveGiftCardAction(id));
  };

  return (
    <Grid item xs={6}>
      <Paper className={classes.root}>
        <Typography variant={'h4'} className={classes.title}>
          {brand_name}
        </Typography>
        <Box className={classes.bannerContainer}>
          <img src={banner_image} className={classes.banner} />
        </Box>
        <Box display="flex" flexDirection="row" justifyContent="space-between" marginTop={10} alignItems="flex-end">
          <Box className={classes.giftCardContainer}>
            <img src={gift_card_image} className={classes.banner} />
          </Box>
          <Box>
            <BaseButton className={classes.bottomButton} to={myGiftCardsPaths.dynamic.card(id)}>
              {t('edit')}
            </BaseButton>

            <BaseButton className={classes.bottomButton} variant="outlined" onClick={handleDeleteClick}>
              <SmallSpinner show={isLoading} /> {t('delete')}
            </BaseButton>
          </Box>
        </Box>
      </Paper>
    </Grid>
  );
};
